import { invokeApiGateway } from '../../auth/api-client';

export interface LambdaConfig {
  functionName: string;
  runtime: string;
  memory: number;
  timeout: number;
  lastModified: string;
  codeSize: number;
  handler: string;
  envVars: Record<string, string>;
  layers: string[];
  vpcConfig: { subnetIds: string[]; securityGroupIds: string[] } | null;
}

export async function listLambdaFunctions(env: string) {
  return invokeApiGateway(`/debug/lambda/functions?env=${env.toLowerCase()}`);
}

export async function fetchLambdaConfigs(env: string): Promise<LambdaConfig[]> {
  const data = await listLambdaFunctions(env);
  return (data.functions || []).map((f: any) => ({
    functionName: f.name,
    runtime: f.runtime || 'N/A',
    memory: f.memory || 0,
    timeout: f.timeout || 0,
    codeSize: f.codeSize || 0,
    lastModified: f.lastModified || '',
    handler: f.handler || '',
    envVars: f.envVars || {},
    layers: f.layers || [],
    vpcConfig: f.vpcConfig || null,
    error: f.error,
  }));
}